// import { useEffect, useState, useContext } from "react";
// import { Modal, Button, Form } from "react-bootstrap";
// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../api/AxiosApi";

// const UserDetailUpdate = ({ show, handleClose, userData, onUpdate }) => {

//   const { PrimaryColor } = useContext(AppThemeContext);

//   const [formData, setFormData] = useState({
//     userId: "",
//     username: "",
//     address: "",
//     city: "",
//     password: "",
//   });

//   const LOGIN_ID = localStorage.getItem("LoginID");

//   useEffect(() => {
//     if (userData) {
//       setFormData({
//         userId: userData.user_id || "",
//         username: userData.username || "",
//         address: userData.address || "",
//         city: userData.city || "",
//         password: userData.password || "",
//       });
//     }
//   }, [userData]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const queryParams = new URLSearchParams({
//         USER_NAME: formData.username,
//         ADDRESS: formData.address,
//         CITY: formData.city,
//         PASSWORD: formData.password,
//         SKey: "XYZ"
//       }).toString();

//       const body = new URLSearchParams({
//         USER_ID: LOGIN_ID,
//         UPDATE_ID: formData.userId,
//         TYPE_ID: "U"
//       }).toString();

//       const url = `${BaseUrl}UPDATE_USER?${queryParams}`;

//       const res = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded"
//         },
//         body: body
//       });

//       const data = await res.json();

//       if (data.success) {
//         onUpdate(data);
//         handleClose();
//       }

//     } catch (err) {
//       console.error(err);
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose} centered>
//       <Modal.Header closeButton style={{ background: PrimaryColor }}>
//         <Modal.Title>Update User</Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <Form onSubmit={handleSubmit}>

//           {/* USER ID (READ ONLY) */}
//           <Form.Group className="mb-2">
//             <Form.Label>User ID</Form.Label>
//             <Form.Control
//               type="text"
//               name="userId"
//               value={formData.userId}
//               readOnly
//             />
//           </Form.Group>

//           <Form.Group className="mb-2">
//             <Form.Label>User Name</Form.Label>
//             <Form.Control
//               type="text"
//               name="username"
//               value={formData.username}
//               onChange={handleChange}
//             />
//           </Form.Group>

//           <Form.Group className="mb-2">
//             <Form.Label>Address</Form.Label>
//             <Form.Control
//               type="text"
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//             />
//           </Form.Group>

//           <Form.Group className="mb-2">
//             <Form.Label>City</Form.Label>
//             <Form.Control
//               type="text"
//               name="city"
//               value={formData.city}
//               onChange={handleChange}
//             />
//           </Form.Group>

//           <Form.Group className="mb-2">
//             <Form.Label>Password</Form.Label>
//             <Form.Control
//               type="text"
//               name="password"
//               value={formData.password}
//               onChange={handleChange}
//             />
//           </Form.Group>

//           <div className="text-end mt-3">
//             <Button onClick={handleClose} style={{ marginRight: "10px" }}>
//               Cancel
//             </Button>

//             <Button type="submit" style={{ background: PrimaryColor }}>
//               Update
//             </Button>
//           </div>

//         </Form>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default UserDetailUpdate;


import { useEffect, useState, useContext } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { AppThemeContext } from "../../../../context/AppThemeContext";
import { BaseUrl } from "../../../../api/AxiosApi";

const UserDetailUpdate = ({ show, handleClose, userData, onUpdate }) => {

    const { PrimaryColor } = useContext(AppThemeContext);

    const [formData, setFormData] = useState({
        userId: "",
        username: "",
        plant_capacity: "",
        dc_capacity: "",
        address: "",
        city: "",
        currency: "",
        lat: "",
        long: "",
        rate: "",
        co2_rate: "",
        total_modules: "",
        module_capacity: "",
        password: "",
        module_make: "",
    });

    const LOGIN_ID = localStorage.getItem("LoginID");

    useEffect(() => {
        if (userData) {
            setFormData({
                userId: userData.user_id || "",
                username: userData.username || "",
                plant_capacity: userData.plant_capacity || "",
                dc_capacity: userData.dc_capacity || "",
                address: userData.address || "",
                city: userData.city || "",
                currency: userData.currency || "",
                lat: userData.lat || "",
                long: userData.long || "",
                rate: userData.rate || "",
                co2_rate: userData.co2_rate || "",
                total_modules: userData.total_modules || "",
                module_capacity: userData.module_capacity || "",
                password: userData.password || "",
                module_make: userData.moudle_make || "",
            });
        }
    }, [userData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const queryParams = new URLSearchParams({
                USER_NAME: formData.username,
                PLANT_CAPACITY: formData.plant_capacity,
                DC_CAPACITY: formData.dc_capacity,
                ADDRESS: formData.address,
                CITY: formData.city,
                CURRENCY: formData.currency,
                LATITUDE: formData.lat,
                LONGITUDE: formData.long,
                RATE: formData.rate,
                CO2: formData.co2_rate,
                TOTAL_MODULES: formData.total_modules,
                MODULE_CAPACITY: formData.module_capacity,
                MODULE_MAKE: formData.module_make,
                PASSWORD: formData.password,
                SKey: "XYZ"
            }).toString();

            const body = new URLSearchParams({
                USER_ID: LOGIN_ID,
                UPDATE_ID: formData.userId,
                TYPE_ID: "U"
            }).toString();

            const url = `${BaseUrl}UPDATE_USERrrrrrrrrrrrrrrrrrrrrrrrrrr?${queryParams}`;

            const res = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: body
            });

            const data = await res.json();

            if (data.success) {
                onUpdate(data);
                handleClose();
            }

        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered size="lg">

            {/* <Modal.Header closeButton style={{ background: PrimaryColor }}>
        <Modal.Title>Update User Details</Modal.Title>
      </Modal.Header> */}

            <Modal.Header
                closeButton
                style={{ background: PrimaryColor, color: "#fff" }}
            >
                <Modal.Title style={{ color: "#fff" }}>
                    Update User Details
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form onSubmit={handleSubmit}>

                    <Row>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>User ID</Form.Label>
                                <Form.Control type="text" value={formData.userId} readOnly />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>Password</Form.Label>
                                <Form.Control name="password" value={formData.password} onChange={handleChange} />
                            </Form.Group>
                        </Col>


                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>User Name</Form.Label>
                                <Form.Control name="username" value={formData.username} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>City</Form.Label>
                                <Form.Control name="city" value={formData.city} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>Plant Capacity</Form.Label>
                                <Form.Control name="plant_capacity" value={formData.plant_capacity} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>DC Capacity</Form.Label>
                                <Form.Control name="dc_capacity" value={formData.dc_capacity} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>Currency</Form.Label>
                                <Form.Control name="currency" value={formData.currency} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>Rate</Form.Label>
                                <Form.Control name="rate" value={formData.rate} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>Latitude</Form.Label>
                                <Form.Control name="lat" value={formData.lat} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>Longitude</Form.Label>
                                <Form.Control name="long" value={formData.long} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>CO2</Form.Label>
                                <Form.Control name="co2_rate" value={formData.co2_rate} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>Total Modules</Form.Label>
                                <Form.Control name="total_modules" value={formData.total_modules} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>Module Capacity</Form.Label>
                                <Form.Control name="module_capacity" value={formData.module_capacity} onChange={handleChange} />
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group className="mb-2">
                                <Form.Label>Module Make</Form.Label>
                                <Form.Control name="module_make" value={formData.module_make} onChange={handleChange} />
                            </Form.Group>
                        </Col>


                    </Row>

                    {/* ADDRESS FULL WIDTH */}
                    <Form.Group className="mb-2">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <div className="text-end mt-3">
                        <Button onClick={handleClose} style={{ marginRight: "10px" }}>
                            Cancel
                        </Button>

                        <Button type="submit" style={{ background: PrimaryColor }}>
                            Update
                        </Button>
                    </div>

                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default UserDetailUpdate;